import { scrubHtml } from "@/lib/utils";

window.scrubHtml = scrubHtml;
